import React, { FC } from "react";
import { IconTag } from "assets/svg";
import { Image } from "antd";
import { FILE_BASE_URL } from "config/apiConfig";
import { Link } from "react-router-dom";
import { Product } from "common/interfaces";
import { useSelector } from "react-redux";
import { RootState } from "store/store";
import { UserTypeEnum } from "common/enums/UserType.enum";
import { ProductStatusEnum } from "common/enums/Product.enum";
import { productPrice } from "common/utils";

interface ProductItemProps {
  item: Product;
}

export const ProductItem: FC<ProductItemProps> = ({ item }) => {
  const { userData } = useSelector((state: RootState) => state.auth);
  return (
    <div
      key={item.category_id}
      data-プロパティ1="soldout"
      className="w-full h-72 flex flex-col justify-start items-start gap-[10px] md:gap-3.5 product-item"
    >
      <Link
        className="w-full h-52 bg-primary-light rounded-md flex flex-col justify-start items-start gap-[10px] md:gap-2.5 overflow-hidden relative"
        to={`/${userData?.type === UserTypeEnum.COMPANY_BUYER ? "buyer" : "seller"}/product/${item.code}`}
      >
        {item.status === ProductStatusEnum.DRAFT ? (
          <div className="w-[70px] h-[70px] left-0 top-[-1px] absolute z-[1]">
            <div className="w-[70px] h-[70px] left-0 top-0 absolute bg-red-dark [clip-path:polygon(0_0,100%_0,0_100%)]" />
            <div className="left-[-3px] top-[35px] absolute origin-top-left -rotate-45 text-center justify-start text-white text-base font-bold font-['Noto_Sans_JP'] leading-relaxed">
              DRAFT
            </div>
          </div>
        ) : (
          item.status === ProductStatusEnum.SOLD && (
            <IconTag className="w-[70px] h-[70px] absolute top-[0px] left-[0px] z-[1]" />
          )
        )}
        <Image
          src={`${FILE_BASE_URL}/${item?.images[0]?.image_url}`}
          preview={false}
          className="!h-full object-cover"
        />
      </Link>
      <div className="w-full flex flex-col justify-start items-start gap-[5px]">
        <Link
          className="w-full text-black text-xl font-normal font-['Noto_Sans_JP'] leading-loose"
          to={`/${userData?.type === UserTypeEnum.COMPANY_BUYER ? "buyer" : "seller"}/product/${item.code}`}
        >
          {item.product_name}
        </Link>
        <div className="w-full text-black text-base font-bold font-['Noto_Sans_JP'] leading-relaxed">
          {productPrice(item)}
        </div>
      </div>
    </div>
  );
};
